var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.isDisabledForNoneFaceforceStaff())?_c('v-btn',{staticClass:"white--text",attrs:{"disabled":_vm.id ? false : true,"small":"","depressed":"","color":"error"},on:{"click":_vm.askForDeleteLead}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-skull-outline ")]),_vm._v(" Lead löschen ")],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }